import ReadMore from 'stimulus-read-more'

export default class extends ReadMore {

}